module.exports = __webpack_public_path__ + "static/gfws-hero-badge-2-3e1e6eb7f4fe45aef820aacd5cf8e4ea.png";